import { render, staticRenderFns } from "./SideSubmenuTree.vue?vue&type=template&id=264e7105&"
import script from "./SideSubmenuTree.vue?vue&type=script&lang=js&"
export * from "./SideSubmenuTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports